import styled from "styled-components";

import { Modal } from "@similarweb/ui-components";

export const ModalContent = styled(Modal.Content)`
    /* Modal component overrides content padding-top to 0, so we set it manually */
    padding: 16px 24px 24px 24px !important;
    gap: 16px;
`;
